<div class="main-container">
  <div class="row mx-0">
    <mat-card class="col-2 filter-tab" *ngIf="!uploadDocs; else uploadDoc">
      <mat-card-content>
        <div class="align-items-end" *ngIf="activeUser.value.superAdmin">
          <button mat-raised-button color="primary" class="btn-block actionBtns" (click)="toggleUpload()">Upload <i
            class="fas fa-arrow-up text-right"></i></button>
        </div>
        <mat-card class="w-100" style="right: 3px; position: relative;">
          <mat-card-content>
            <div>
              <mat-form-field class="search-input w-100">
                <mat-label>Search Documents</mat-label>
                <input matInput placeholder="Search Documents..." [(ngModel)]="searchValue"
                       (keyup)="inputSearch(searchValue)" autocomplete="nope" />
              </mat-form-field>
            </div>
            <div>
              <h3 class="text-center">Filter Options</h3>
            </div>
            <mat-button-toggle-group style="width: 100%" vertical value="default" [(ngModel)]="btnGroup">
              <mat-button-toggle value="default" (click)="clearFilter()">All</mat-button-toggle>
              <mat-button-toggle *ngFor="let type of documentType"
                                 (click)="filterDocuments(type)"
                                 value="{{type.label}}">{{type.label}}</mat-button-toggle>
            </mat-button-toggle-group>
          </mat-card-content>
        </mat-card>
      </mat-card-content>
    </mat-card>
    <mat-card class="col-10">
      <mat-card-header>
        <mat-card-title class="col-6">Documents</mat-card-title>
        <button mat-icon-button color="secondary" class="btn refreshBtn" (click)="getDocuments()"><i
          class="fas fa-sync-alt fa-lg"></i></button>
      </mat-card-header>
      <mat-card-content>
        <table mat-table [dataSource]="documents" matSort matSortActive="title" matSortDirection="asc"
               class="table-striped" matSortDisableClear>

          <ng-container class="col-container" matColumnDef="download">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let document">
              <button mat-icon-button class="btn download-btn" (click)="downloadDocument(document)"><i
                class="fas fa-file-download"></i></button>
            </td>
          </ng-container>

          <ng-container class="col-container" matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
            <td mat-cell class="docview" *matCellDef="let document"
                (click)="viewDocument(document)">{{document.title}}</td>
          </ng-container>

          <ng-container class="col-container" matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
            <td mat-cell class="docview" *matCellDef="let document"
                (click)="viewDocument(document)">{{document.description}}</td>
          </ng-container>

          <ng-container matColumnDef="fileSize" class="text-center">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Size</th>
            <td mat-cell class="docview" *matCellDef="let document"
                (click)="viewDocument(document)">{{document.fileSize | fileSize: 'filesize'}}</td>
          </ng-container>

          <ng-container class="col-container" matColumnDef="uploadDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
            <td mat-cell class="docview" *matCellDef="let document"
                (click)="viewDocument(document)">{{document.uploadDate | displayDate: 'Date' : dateColumn}}</td>
          </ng-container>

          <ng-container class="col-container" matColumnDef="fileName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>File Name</th>
            <td mat-cell class="docview" *matCellDef="let document"
                (click)="viewDocument(document)">{{document.filename}}</td>
          </ng-container>

          <ng-container class="col-container" matColumnDef="createdBy">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Created By</th>
            <td mat-cell class="docview" *matCellDef="let document"
                (click)="viewDocument(document)">{{document.createdBy}}</td>
          </ng-container>

          <ng-container class="col-container" matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let document">
              <button class="delete-icon-button" *ngIf="activeUser.value.superAdmin" mat-icon-button
                      (click)="confirmDelete(document)">
                <i class="warnRed fas fa-trash-alt"></i>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columns"></tr>
          <tr class="docRow" mat-row *matRowDef="let row; columns: columns; let index = index"
              (mouseleave)="hoveredRow = null" (mouseover)="showDelete(row.id)"></tr>

        </table>
        <mat-paginator [pageSizeOptions]="pageSizeOptions"></mat-paginator>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<ng-template #uploadDoc>
  <mat-card class="col-2 filter-tab">
    <mat-card-content>
      <div class="align-items-end">
        <button mat-raised-button class="btn btn-danger btn-block actionBtns cancel-btn" (click)="toggleUpload()">Cancel
          <i class="fas fa-times text-right"></i></button>
      </div>
      <div class="row">
        <div class="col">
          <mat-accordion displayMode="flat" hideToggle>
            <mat-form-field class="search-input w-100">
              <mat-label>Title</mat-label>
              <input matInput placeholder="Title" class="title-input" [(ngModel)]="uploadTitle" autocomplete="false"
                     required />
            </mat-form-field>
            <mat-form-field class="search-input w-100">
              <mat-label>Description</mat-label>
              <input matInput placeholder="Description" class="description-input" [(ngModel)]="uploadDescription"
                     autocomplete="false" required />
            </mat-form-field>
            <mat-form-field class="upload-categories">
              <mat-label>Document Category</mat-label>
              <mat-select>
                <mat-option *ngFor="let uploadCat of documentType"
                            (click)="setUploadCategory(uploadCat.label, uploadCat.value )"
                            [value]="uploadCat.value">{{uploadCat.label}}</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="text-center">
              <p><i>Acceptable file types are, .pdf, .png, .jpg, .doc, .docx, .pptx</i></p>
              <p><b><i>Preferred file type is .pdf</i></b></p>
            </div>
            <hr>
          </mat-accordion>
        </div>
      </div>
      <div class="align-items-end">
        <input [hidden]="true" id="input-file-id" type="file" (change)="fileSelected($event)" />
        <label for="input-file-id" class="btn btn-primary btn-block actionBtns input-btn">Select Documents <i
          class="fas fa-plus"></i></label>
        <button mat-raised-button class="btn btn-success btn-block actionBtns submit-btn"
                [disabled]="uploadFile?.size <= 0"
                (click)="uploadDocument()">
          Submit <i class="fas fa-check text-right"></i></button>
      </div>
      <hr>
      <div class="text-center">
        <h6 *ngIf="uploadFile; else noFile"><i>{{uploadFile[0].name}}</i></h6>
        <ng-template #noFile><h6><i>No file selected</i></h6></ng-template>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>
